import './App.css';
import Footer from './components/Footer.js';

import PresidentsMessage from './components/PresidentsMessage.js';
import AboutUs from './pages/AboutUs.js';
import Academics from './pages/Academics.js';
import AdmissionInfo from './pages/AdmissionInfo.js';
import Home from './pages/Home';
import TrusteesInfo from './pages/TrusteesInfo.js';
import Gallery from './pages/Gallery.js';
import { createBrowserRouter } from 'react-router-dom';
import { RouterProvider } from 'react-router';
import Terms from './pages/Terms.js';
import PrivacyPolicy from './pages/PrivacyPolicy.js';
import Layout from './pages/Layout.js';
import StudentReviews from './pages/StudentReviews.js';
import HangeshwarPublicSchool from './pages/HangeshwarPublicSchool.js';



const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Layout>
        <Home />
        <AboutUs />
        <PresidentsMessage />
        <Gallery />
        <TrusteesInfo />
        <Academics />
        <AdmissionInfo />
        <StudentReviews />
        <Footer />
      </Layout>
    ),
  },
  {
    path: '/terms',
    element: (
      <Layout>
        <Terms />
      </Layout>
    ),
  },
  {
    path: '/privacy-policy',
    element: (
      <Layout>
        <PrivacyPolicy />
      </Layout>
    ),
  },
  {
    path: '/hangeshwarPublicSchool',
    element: (
      <Layout>
        <HangeshwarPublicSchool />
      </Layout>
    ),
  },
]);

function App() {

  return (
   <RouterProvider router={router} />
  );
}

export default App;
